export default "__VITE_ASSET__DkrGtEnP__"